import { render } from "./Essenza.vue?vue&type=template&id=c5899d9a&scoped=true"
import script from "./Essenza.vue?vue&type=script&lang=js"
export * from "./Essenza.vue?vue&type=script&lang=js"

import "./Essenza.vue?vue&type=style&index=0&id=c5899d9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c5899d9a"

export default script